import React, { useMemo } from "react";
import { Node } from "@tiptap/core";
import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";
import { useSelector } from "react-redux";
import ChatTableV2 from "@/components/common/ChatTableV2";

const MemoizedChatTableV2 = React.memo(ChatTableV2);

const EditorTableComponent = React.memo(({ node }) => {
  const { qid, tableId } = node.attrs;

  const fpAppV4Data = useSelector((state) => state.fpAppV4Data);

  const queryAnswer = useMemo(
    () => fpAppV4Data.queryAnswers.find((qa) => qa.qid === qid),
    [fpAppV4Data.queryAnswers, qid]
  );

  const tableData = queryAnswer?.tableData[tableId];

  const sourceMap = useMemo(() => {
    const answer = queryAnswer?.toolResponse?.answer;
    if (answer) {
      return answer.source_map || answer.sourceMap || {};
    }
    return {};
  }, [queryAnswer]);

  const memoizedProps = useMemo(
    () => ({
      tableData,
      sourceRef: sourceMap,
      qid,
    }),
    [tableData, sourceMap]
  );

  return (
    <NodeViewWrapper as="span">
      {tableData?.headers?.length ? (
        <MemoizedChatTableV2 {...memoizedProps} />
      ) : null}
    </NodeViewWrapper>
  );
});

const EditorTableNode = Node.create({
  name: "editor-table",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      tableId: {
        default: null,
      },
      qid: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "editor-table",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["editor-table", HTMLAttributes];
  },

  addNodeView() {
    return ReactNodeViewRenderer(EditorTableComponent);
  },

  addInputRules() {
    return [
      {
        find: /\\editor-table$/,
        replace: () =>
          this.editor.commands.insertContent("<editor-table></editor-table>"),
      },
    ];
  },
});

export default EditorTableNode;
